//Aqui
//Alterar para em projeto/producao e/ou Homolocao
// versao.js basutlaxios.js baseultapi.js api.js e ambiente.js
//Em Projeto
//const baseurlapi = "http://localhost/flag.heishop.webapi/api"
//const baseurlapi = "http://qa.flag.com.br/Flag.Heishop.WebApi/api"
//Homologacao
//const baseurlapi = "http://qa.flag.com.br/Flag.Heishop.WebApi/api"
//Producao
////const baseurlapi = "http://producao.flag.com.br/Flag.Heishop.WebApi/api"
const baseurlapi = "https://prd.heitools.com.br/Flag.Heishop.WebApi/api"

export default baseurlapi